'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { Barcode } from 'shipping-and-returns/containers/ReturnMethodsInfoContainer/components//Barcode/Barcode'
import { ContentContainer } from 'shipping-and-returns/containers/ReturnMethodsInfoContainer/components/ContentContainer/ContentContainer'
import { sendOnClickReturnStore } from 'shipping-and-returns/utils/analytics/analyticsEvents'
import { Events } from 'webview/constants/events'
import { sendAppEvent } from 'webview/utils/sendAppEvent'

interface StoreContentProps {
	readonly barcode?: string | null
	readonly orderId?: string
	readonly onCloseEvent: () => void
	readonly isMyPurchasesPage?: boolean
	readonly onLocateStoreClick?: () => void
}
export function StoreContent({
	barcode,
	orderId,
	onCloseEvent,
	isMyPurchasesPage,
	onLocateStoreClick,
}: StoreContentProps) {
	const { t } = useLabels()
	const { isSmall } = useResponsive()
	const { isApp } = useMasterData()

	const locateStoreHandler = (e: React.MouseEvent) => {
		sendOnClickReturnStore()
		onCloseEvent()

		if (isApp) {
			e.preventDefault()
			sendAppEvent({ event: Events.Shops })
			return
		}

		onLocateStoreClick?.()
	}

	return (
		<ContentContainer
			ecoContent={t('myPurchases.online.details.returns.sustainable.bodycopy')}
			action={{
				onClick: locateStoreHandler,
				dataTestId: 'myPurchases.returns.findStore.button',
				text: t('myPurchases.online.details.returns.findStore.button'),
			}}
			description={
				barcode && isMyPurchasesPage && isSmall ? (
					<Barcode orderId={orderId} barcode={barcode} />
				) : (
					t('myPurchases.online.details.returns.store.desktop.bodycopy')
				)
			}
		/>
	)
}
